import { BasePublicApi } from '#packages/apilib';

import type { SlotOpenerScope } from './scope';
import { createSlotOpenerDragPlugin } from './dragPlugins/baseDragPlugin';
import { createSlotOpenerDragPluginAddPanel } from './dragPlugins/addPanelDragPlugin';
import {
  toggleSlotOpenerUserPreferences,
  getSlotOpenerUserPreferences,
} from './utils';

export class SlotOpenerApi extends BasePublicApi<SlotOpenerScope> {
  dragPlugin = createSlotOpenerDragPlugin(this.scope);
  dragPluginAddPanel = createSlotOpenerDragPluginAddPanel(this.scope);

  getActiveSlot = () =>
    this.scope.store.getShouldOpenSlot()
      ? this.scope.store.getAvailableSlot()
      : null;
  toggleSlotOpenerUserPreferences = toggleSlotOpenerUserPreferences;
  getSlotOpenerUserPreferences = getSlotOpenerUserPreferences;
  getCompPosition = this.scope.slotOpenerPrivateApi.getCompPosition;
}
